<template>
  <div>
    <div :style="title.content_background_color ? getDynamicPageBg(title) : ''">
      <div class="container pb-3">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <h1 class="lyon-display-medium-32">{{ title.value }}</h1>
          </div>
          <div v-if="canEditCms && editCmsRoute">
            <router-link :to="{ name: editCmsRoute, params: { id: menuId } }">
              <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Edit" />
            </router-link>
          </div>
          <div v-if="quickLinkList" ref="parentQuickLinkContainer" class="ml-2">
            <custom-quick-link-section :quick-link-list="quickLinkList" />
          </div>
        </div>

        <info-block-loader v-if="dataLoading" :textLine="10" infoType="event"/>
        <div v-else class="d-flex row justify-content-between">
          <div v-if="photos && photos.length > 0" class="col-lg-7 col-xl-4 mb-4">
            <img class="featured-img" :src="photos[0].url" alt>
          </div>
          <div :class="(photos && photos.length === 0) ? 'col-lg-12 col-xl-12 main-content' : 'col-lg-5 col-xl-7 main-content'">
            <div class="regular-16 custom-html-text" v-html="description" />
            <div v-if="applyButtonLabel && applyButtonToggled" class="mt-3">
              <button class="btn btn-primary btn-md mb-3" @click="applyButtonRedirect(applyButtonPath)">
                {{ applyButtonLabel }}
              </button>
            </div>
            <!-- <div v-if="upcomingLinkLabel" class="mt-2 mb-5">
              <a class="typo-color-blue bold-14 cursor-pointer" @click="upcomingLinkPath ? applyButtonRedirect(upcomingLinkPath) : null">{{ upcomingLinkLabel }}</a>
            </div> -->
            <!-- <div v-if="showCurrentProgramDetail" class="mt-2 mb-5">
              <div v-if="currentProgramId">
                <router-link
                  :to="{
                    name: currentProgramDetailsRoute,
                    params: { id: currentProgramId, menuId: menuId }
                  }"
                >
                  <span class="typo-color-blue bold-14">VIEW CURRENT PROGRAM DETAILS</span>
                </router-link>
              </div>
              <div v-else>
                <span v-b-tooltip.hover class="typo-color-blue bold-14" title="Currently no progarm details available">
                  VIEW CURRENT PROGRAM DETAILS
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="body" :style="body.content_background_color ? getDynamicPageBg(body) : ''">
      <div class="container">
        <div class="regular-16 custom-html-text" v-html="body.value" />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'
import { mapGetters } from 'vuex'
import CustomQuickLinkSection from '@/components/QuickLink/CustomQuickLinkSection.vue'
import InfoBlockLoader from '@/components/Loaders/InfoBlockLoader.vue'

export default {
  name: 'ScientificActivitiesCustomStaticContent',
  mixins: [mixin],
  components: { InfoBlockLoader, CustomQuickLinkSection},
  props: {
  contentStyle: String,
  photos: Array,
  description: String,
  dataLoading: Boolean,
  title: {
    type: Object,
    default: null
  },
  body: {
    type: Object,
    default: null
  },
  applyButton: {
    type: Object,
    default: null
  },
  applyButtonLabel: {
    type: String,
    default: null
  },
  applyButtonPath: {
    type: String,
    default: null
  },
  upcomingLinkPath: {
    type: String,
    default: null
  },
  upcomingLinkLabel: {
    type: String,
    default: null
  },
  currentProgramId: {
    default: null
  },
  currentProgramDetailsRoute: {
    type: String,
    default: null
  },
  quickLinkList: Array,
  editCmsRoute: String,
  showCurrentProgramDetail: Boolean,
  menuId: Number
  },
  computed: {
    ...mapGetters(['canEditCms']),
    applyButtonToggled() {
      return this.applyButton ? this.applyButton.value === 'true' : !this.applyButton
    }
  }
}
</script>
